import Icons from "icons/sidebar";

const index = [
  {
    title: "Relatórios",
    Icon: Icons.AssessmentOutlinedIcon,
    path: "/dashboard/admin-reports"
  },
  {
    title: "Resumo",
    Icon: Icons.DashboardOutlinedIcon,
    path: "/dashboard/summary"
  },
  {
    title: "Agenda",
    Icon: Icons.EventAvailableIcon,
    path: "/dashboard/appointments"
  },
  {
    title: "Histórico",
    Icon: Icons.ListIcon,
    path: "/dashboard/history"
  },
  {
    title: "Serviços",
    Icon: Icons.BusinessCenterIcon,
    path: "/dashboard/services"
  },
  {
    title: "Profissionais",
    Icon: Icons.PeopleAltIcon,
    path: "/dashboard/users"
  },
  {
    title: "Empresas",
    Icon: Icons.StoreIcon,
    path: "/dashboard/companies"
  },
];

export default index;
